export const RATES_ENDPOINT_KEY = 'rates'
